import {AktionTypeEnum} from "../../../models/api/insight/AktionTypeEnum";
import type {Insight} from "../../../models/api/insight/Insight";
import {InsightTypeEnum} from "../../../models/api/insight/InsightTypeEnum";
import {KategorieEnum} from "../../../models/api/insight/KategorieEnum";
import {LizenzEnum} from "../../../models/api/insight/LizenzEnum";

const insights: Array<Insight> = [
    {
        id: "20260701-widerruf",
        datum: "01.07.2026",
        kategorie: KategorieEnum.DESKTOP,
        type: InsightTypeEnum.VERBESSERTES_FEATURE,
        title: "Update Widerrufsfunktion",
        lizenz: [LizenzEnum.KURSE],
        content: [
            "Wir haben erste Rückmeldungen zur neuen Funktion erhalten und eine kleine Anpassung vorgenommen: Das Feld"
            + " „Geburtsdatum“ wird im Widerrufsformular nicht länger abgefragt.",
            "Nun interessiert uns, wie die neue Funktion bei euch im Alltag ankommt:<br>Reicht euch die Benachrichtigung"
            + " per E-Mail oder wünscht ihr euch zusätzlich eine Übersicht der eingegangenen Widerrufe direkt im"
            + " HiOrg-Server?"
        ],
        aktions: [
            {
                type: AktionTypeEnum.BLOG,
                text: "Details im Blog",
                url: "https://info.hiorg-server.de/2026/06/update-widerrufsfunktion/",
            },
            {
                type: AktionTypeEnum.FORUM,
                text: "Rückmeldung im Forum",
                url: "https://forum.hiorg-server.de/t/widerrufsbutton-ab-juni-2026-wir-kuemmern-uns-darum/2816",
            },
        ],
    },
    {
        id: "20260701-einstellungen",
        datum: "01.07.2026",
        kategorie: KategorieEnum.DESKTOP,
        type: InsightTypeEnum.VERBESSERTES_FEATURE,
        title: "Update Einstellungsseite",
        lizenz: [LizenzEnum.KURSE, LizenzEnum.PRO],
        content: [
            "⚙️ Im Einstellungsbereich (System → Einstellungen) wurde die bisherige Kachel „Rechnungen /"
            + " Anforderungsformular“ durch die beiden neuen Bereiche „Dienste“ und „Rechnungsstellung“ ersetzt.<br>"
            + " Die klarere Aufteilung sorgt für eine bessere Übersicht und macht die einzelnen Funktionen leichter"
            + " verständlich.",
        ],
        aktions: [],
    },
    {
        id: "20260701-allgemein",
        datum: "01.07.2026",
        kategorie: KategorieEnum.DESKTOP,
        type: InsightTypeEnum.VERBESSERTES_FEATURE,
        title: "Allgemeine Verbesserungen",
        lizenz: [LizenzEnum.KURSE, LizenzEnum.PRO],
        content: [
            "<ul><li>💰 Auswahl / Vorschau Rechnungsempfänger</li>"
            + "<li>⚙️ Verifizierung der Admin-Adresse als gesicherte Kontaktmöglichkeit</li>"
            + "<li>🎓 reservierte Plätze werden bei der Ausgabe von TN-Bescheinigungen übersprungen</li>"
            + "<li>🎓 JSON-Export von Veranstaltungen beinhaltet nun Kursausbilder</li>"
            + "<li>📄 neue Variable: <code>[[$girocode]]</code> zur Ausgabe eines GiroCodes auf Rechnungen</li></ul>",
        ],
        aktions: [],
    },
];

export {
    insights,
};
